import { render } from "./detail_1.vue?vue&type=template&id=07925b22"
import script from "./detail_1.vue?vue&type=script&lang=js"
export * from "./detail_1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__